import * as React from 'react';
import { PriceType } from '../../classes/price-type';
import { getFocusableChildren, bindKeypress } from '../../helpers/window-helpers';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';

export interface IDiagnosticModal {
    modalKey: string;
    title: string;
    message: string;
    closeFunction?: any;
    goToSeatmapFunction?: any;
    modalClass?: string;
    priority?: number;
    appSettings: IAppSettingsModel;
}

class DiagnosticModal<T extends IDiagnosticModal> extends React.Component<T, { lastFocused: any }> {

    constructor(props) {
        super(props);
        this.state = { lastFocused: null };
        console.log("Pop-up shown (" + props.modalKey + ")");
    }

    componentDidMount() {
        this.setState({ lastFocused: document.activeElement });
        (document.activeElement as any).blur();
        const modal = document.getElementById('modal-container');
        if (modal != null && this.props.closeFunction != null) {
            let focusableElements = getFocusableChildren(modal);
            window.addEventListener('keydown', event => bindKeypress.bind(this)(event, focusableElements, this.props.closeFunction.bind(this)));
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', bindKeypress.bind(this));
        if (this.state.lastFocused !== null) {
            this.state.lastFocused.focus();
        }
    }

    render() {
        var modalClassName = 'modal-wrapper';

        if (this.props.modalClass) {
            modalClassName = this.props.modalClass + ' modal-wrapper';
        }

        if (this.props.priority) {
            modalClassName = modalClassName + " priority-" + this.props.priority;
        }

        return (
            <div tabIndex={-1} className={modalClassName} id="modal-wrapper" ref="modalWrapper" aria-live="polite">
                <div id="modal-overlay" className="modal-overlay" tabIndex={-1} onClick={this.props.closeFunction ? () => { this.props.closeFunction() } : null}></div>
                <section role="dialog" className="modal-container modal-large modal-diagnostic">
                    <div role="document" className="stack">
                        {this.renderModalContent()}
                        <button className="btn-diagnostic-close" onClick={this.props.closeFunction ? () => { this.props.closeFunction() } : null}>
                            <svg className="close-filters-icon"><use xlinkHref="#icon-close" /></svg>
                            <span className="visually-hidden">Close</span>
                        </button>
                    </div>
                </section>
            </div>
        );
    }

    getFacilityConfigUrl() {
        return `${this.props.appSettings.venueBuilderRootUrl}/configuration/edit/${this.props.appSettings.facilityConfigurationId}?venueId=${this.props.appSettings.venueLevels[0].venueId}`;
    }

    getVenueConfigUrl() {
        return `${this.props.appSettings.venueBuilderRootUrl}/Venues/Index/${this.props.appSettings.venueLevels[0].venueId}`;
    }

    getBrandConfigUrl() {
        return `${this.props.appSettings.venueBuilderRootUrl}/Brands/Index/${this.props.appSettings.brandId}`;
    }

    getPriceTypeSettingUrl(priceTypeConfigId: number) {
        return `${this.props.appSettings.venueBuilderRootUrl}/PriceTypeSettings?priceTypeId=${priceTypeConfigId}#priceType-${priceTypeConfigId}`;
    }

    getPriceTypeConfigDisplay(priceType: PriceType) {
        if (priceType.id != "00000000-0000-0000-0000-000000000000") {
            return <a href={this.getPriceTypeSettingUrl(priceType.priceTypeId)}>Config</a>;
        }
        else {
            return "No Config Found";
        }
    }

    public renderModalContent() {
        return (
            <>
                <div className="modal-content stack">
                    <h2 className="heading-general">SmartSeat Diagnostic Display</h2>
                </div>
                <ul>
                    <li><a href="/SmartSeatMonitor">Monitor Page</a></li>
                    <li><a href={this.props.appSettings.venueBuilderRootUrl}>Venue Builder</a></li>
                </ul>
                <div dangerouslySetInnerHTML={{ __html: this.props.message }} />
                <div className="modal-group">
                    <h3>Configurations</h3>
                    <a href={this.getFacilityConfigUrl()} className="btn-primary">Facility: {this.props.appSettings.facilityConfigurationName}</a>
                    <a href={this.getVenueConfigUrl()} className="btn-primary">Venue</a>
                    <a href={this.getBrandConfigUrl()} className="btn-primary">Brand</a>
                </div>
                <div className="modal-group">
                    <h3>Pricing</h3>
                    <h4>Price Types</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Config</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.appSettings.priceTypeSettings.map(priceType => (
                                <tr>
                                    <td>{priceType.priceTypeId}</td>
                                    <td>{priceType.title}</td>
                                    <td>{this.getPriceTypeConfigDisplay(priceType)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <h4>Zones</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Description</th>
                                <th>Prices</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.appSettings.seatZones.map(zone => (
                                <tr>
                                    <td>{zone.zoneId}</td>
                                    <td>{zone.description}</td>
                                    <td>
                                        <table>
                                            <thead>
                                                <th>Price</th>
                                                <th>Fee Amount</th>
                                                <th>Price Type ID</th>
                                            </thead>
                                            <tbody>
                                                {zone.prices.map(price => (
                                                    <tr>
                                                        <td>$ {price.price}</td>
                                                        <td>$ {price.feeAmount}</td>
                                                        <td>{price.priceTypeId}</td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
}

export default DiagnosticModal;